var error = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof foo !== "undefined") return resolve();
	__webpack_require__.l("https://happy-kirch-47dfe1.netlify.app/remoteEntry.js", function(event) {
		if(typeof foo !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		error.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		error.name = 'ScriptExternalLoadError';
		error.type = errorType;
		error.request = realSrc;
		reject(error);
	}, "foo");
}).then(function() { return foo; });